import { apiService } from "./api.service";
import { FeatureFlag, FeatureFlagCreate } from "../models/feature-flag.model";

export class FeatureFlagService {
  private static BASE_PATH = "/api/v1/admin/feature-flags";

  static async getAll(): Promise<FeatureFlag[]> {
    const response = await apiService.get(this.BASE_PATH);
    if (!response.success) return [];
    if (Array.isArray(response.data)) {
      return response.data as FeatureFlag[];
    }
    return [];
  }

  static async create(flag: FeatureFlagCreate): Promise<FeatureFlag | null> {
    const response = await apiService.post(this.BASE_PATH, flag);
    if (!response.success) return null;
    return response.data as FeatureFlag;
  }

  static async update(flagId: string, flag: FeatureFlagCreate): Promise<FeatureFlag | null> {
    const response = await apiService.put(`${this.BASE_PATH}/${flagId}`, flag);
    if (!response.success) return null;
    return response.data as FeatureFlag;
  }

  static async remove(flagId: string): Promise<boolean> {
    const response = await apiService.delete(`${this.BASE_PATH}/${flagId}`);
    return response.success;
  }
}
